// SPDX-License-Identifier: AGPL-3.0-or-later

import {AccountScopedWork} from '@app/features/platform/state/AccountScopedWork';
import {makeAutoObservable} from 'mobx';

// Micup: the one-time interest picker a new account and an older account in the rollout must finish; READY says whether
// it is due.
export class InterestOnboardingState {
	accountKey: string | null = null;
	due: {accountKey: string} | null = null;
	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
	}

	bindAccount(accountKey: string | null): void {
		if (accountKey === this.accountKey) return;
		this.reset();
		this.accountKey = accountKey;
	}

	applyReady(accountKey: string, required: boolean): void {
		this.bindAccount(accountKey);
		this.due = required ? {accountKey} : null;
	}

	isDue(accountKey: string | null): boolean {
		return accountKey !== null && this.due?.accountKey === accountKey;
	}

	finish(accountKey: string): void {
		if (this.due?.accountKey === accountKey) this.due = null;
	}

	reset(): void {
		this.accountKey = null;
		this.due = null;
	}
}

const InterestOnboarding = new InterestOnboardingState();
AccountScopedWork.registerCancellation(InterestOnboarding.reset);
export default InterestOnboarding;
